import { AlertController, LoadingController } from 'ionic-angular';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NavController, NavParams } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { of } from 'rxjs/observable/of'
import { AuthService } from '../../providers/dbservice/authservice';
import { DbserviceProvider } from '../../providers/dbservice/dbservice';
import { HomePage } from '../../pages/home/home';
import { MemberAddPage } from '../../pages/member/member_add';
import { ResetpwdLinkPage } from '../resetpwd/resetpwdLink';
import { ResetpasswordPage } from '../resetpwd/resetpassword';
import { Member } from '../../models/interfaces/member.model';
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})

export class LoginPage {

  currentUser: Member;
  loading: any;
  loginForm: FormGroup;
  mb_email_id: string = "";
  mb_password: string = "";
  private styleName: string ="";

  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, public alertCtrl: AlertController,
    public loadingCtrl: LoadingController, private db: DbserviceProvider, private storage: Storage) {
    console.log('Login constructor');
    this.styleName=this.configService.getConfig("STYLENAME");
    this.storage.get('mb_email_id').then(mb_email_id => {
      this.mb_email_id = mb_email_id;
    });

    this.storage.get('mb_password').then(mb_password => {
      this.mb_password = mb_password;
    });

    this.loginForm = this.formBuilder.group({
      mb_email_id: [],
      mb_password: [],
    });
  }
  //https://embed.plnkr.co/plunk/9luTng
  loginUser() {
    console.log("LoginPage loginUser");

    this.authService.login(this.loginForm.value.mb_email_id, this.loginForm.value.mb_password).subscribe(ret => {
      if (ret['status'] === '0') {

        if (ret.data[0].mb_password_reset_hash !== null) {
          let alert = this.alertCtrl.create({
            subTitle: "First time you cunt! Change password and don't forget to fuck the whip!",
            buttons: ['OK']
          });
          alert.present();
          this.navCtrl.push("ResetpasswordPage", { "verification_code": ret.data[0].mb_password_reset_hash });
          return;
        }

        this.authService.isLoggedIn = true;

        //set last login
        this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "update member set mb_lastlogin= '" + new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate(), new Date().getHours() + 8).toISOString().slice(0, 10) + "' where mb_id='" + ret.data[0].mb_id + "'" })
        .subscribe((ret3) => {
          //this.navCtrl.pop();
        });

        this.authService.currentUser = of(ret.data[0]);

        return this.db.dbCol({
          "action": "select", "mapObject": "vw_member_privilege",
          "sqlExtended": " where mb_id='" + ret.data[0].mb_id + "'",
        }).subscribe(priv => {
          this.authService.privs = [];
          for (var j = 0; j < (<any>priv).length; j++) {
            this.authService.privs.push(priv[j].pv_name);
          }

          this.storage.set('mb_email_id', this.loginForm.value.mb_email_id);
          this.storage.set('mb_password', this.loginForm.value.mb_password);
          this.navCtrl.push(HomePage);

        });


      } else {
        let alert = this.alertCtrl.create({
          subTitle: "Your Login Username or Password is invalid",
          buttons: ['OK']
        });
        alert.present();
        this.authService.isLoggedIn = false;
        this.authService.currentUser = null;
      }
    });
  }

  register() {
    this.navCtrl.push(MemberAddPage);
  }
  resetPwd() {
    this.navCtrl.push(ResetpwdLinkPage);
  }

  goback() {
    console.log('LoginPage goback');
    this.navCtrl.push(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts